import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	Input,
	OnInit,
	Output,
} from '@angular/core';
import { UtilService } from '@service/util/util.service';
import { Cargochief } from '@service/cargochief/cargochief.service';
import { CarrierFeedback, DATE_MDY, RestService } from 'cargo-chief-commons';
import { TRUCK_TYPES } from '@domain/constants/truck-types';
import { UrlService } from '@service/url/url.service';
import { CARRIER_FEEDBACK_SETTINGS } from '@domain/constants/app-variables';

@Component({
	selector: 'app-carrier-feedbacks',
	templateUrl: './carrier-feedbacks.component.html',
	styleUrls: ['./carrier-feedbacks.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CarrierFeedbacksComponent implements OnInit {
	@Input() carrierId: string = null;
	@Input() accountId: number = null;
	@Output() recentFeedbackList: EventEmitter<Array<CarrierFeedback>> = new EventEmitter();
	@Output() feedbackClicked: EventEmitter<any> = new EventEmitter();

	carrierFeedbackList: Array<CarrierFeedback> = [];
	DATE_MDY = DATE_MDY;

	constructor(
		private urlService: UrlService,
		private restService: RestService,
		private cargochiefService: Cargochief,
		public utilService: UtilService
	) {}

	ngOnInit() {
		const carrierFeedbacks = this.cargochiefService.getCarrierFeedbackList(this.carrierId);
		if (!this.utilService.isNullOrUndefined(carrierFeedbacks)) {
			this.carrierFeedbackList = carrierFeedbacks;
		} else {
			const url = this.urlService.getCarrierFeedback(this.carrierId, {
				pageSize: 200 /* CARRIER_FEEDBACK_SETTINGS.PAGE_SIZE  TODO: Change back when notes v2 is fully implemented */,
			});
			this.restService.GET(url).subscribe((response) => {
				this.carrierFeedbackList = response['data'];
				if (
					this.carrierFeedbackList.length ==
					200 /* CARRIER_FEEDBACK_SETTINGS.PAGE_SIZE  TODO: Change back when notes v2 is fully implemented */
				) {
					this.cargochiefService.setCarrierFeedbackList(this.carrierId, this.carrierFeedbackList);
				}
				if (
					!this.utilService.isNullOrUndefined(this.carrierFeedbackList) &&
					this.carrierFeedbackList.length > 0
				) {
					this.recentFeedbackList.emit(this.carrierFeedbackList);
				}
			});
		}
	}

	formatLocationData(carrierFeedback: CarrierFeedback) {
		let locationString = '';
		if (carrierFeedback.truckType == TRUCK_TYPES.LANE) {
			locationString = locationString + 'Lane: ';
		}
		let trailerTypesString = '';
		if (carrierFeedback.trailerTypes) {
			const trailerTypesSplit = carrierFeedback.trailerTypes.split(',');
			trailerTypesSplit?.forEach((trailerType, index) => {
				const formattedTrailerType = trailerType.trim().toUpperCase().substring(0, 1);
				const toAppend = index == trailerTypesSplit.length - 1 ? '' : ',';
				trailerTypesString += formattedTrailerType + toAppend;
			});
		}

		return (
			locationString +
			carrierFeedback.originCity +
			', ' +
			carrierFeedback.originState +
			' -> ' +
			carrierFeedback.destCity +
			', ' +
			carrierFeedback.destState +
			' (' +
			trailerTypesString +
			')'
		);
	}

	getResult(carrierFeedback: CarrierFeedback) {
		if (carrierFeedback.booked) {
			return 'Booked';
		} else {
			return `Not Booked ${
				!this.utilService.isNullOrUndefined(carrierFeedback.loadNotBookedReason)
					? '(' + carrierFeedback.loadNotBookedReason + ')'
					: ''
			}`;
		}
	}

	getFirstName(userOrContactObject: object) {
		return userOrContactObject ? userOrContactObject['firstName'] : null;
	}

	public getSize(): number {
		return CARRIER_FEEDBACK_SETTINGS.PAGE_SIZE;
	}
}
